import { images } from '../assets';

export const getGameOverAsset = (result) => {
    if (result === "You win") return images.happyCatGif;
    if (result === "You lose") return images.sadHamsterGif;
    return images.officeHandshakeMeme;
};

export const getEloChangeColor = (change) => {
    if (change > 0) return "green";
    if (change < 0) return "red";
    return "gray";
};

